G.LineEditor = function(){

	Phaser.Group.call(this,game);

	this.gfx = game.add.graphics();
	this.gfx.fixedToCamera = true;

	this.points = {
		x: [],
		y: []
	};

	this.currentIndex = null;
	this.pointerStart = new Phaser.Point(0,0);

	this.interpolation = 'linearInterpolation';

	game.input.onDown.add(function(pointer){
		this.currentIndex = this.findCurrentIndex(pointer);
		if (this.currentIndex !== null){
			this.pointerStart.x = pointer.x;
			this.pointerStart.y = pointer.y;
		}
	},this);


	game.input.onUp.add(function(pointer){
		this.currentIndex = null;
	},this);

	this.keys = game.input.keyboard.addKeys({
		Z: Phaser.Keyboard.Z,
		X: Phaser.Keyboard.X,
		C: Phaser.Keyboard.C,
		A: Phaser.Keyboard.A,
		S: Phaser.Keyboard.S,
		D: Phaser.Keyboard.D
	});

	this.keys.Z.onDown.add(function(){
		this.interpolation = 'catmullRomInterpolation';
	},this);

	this.keys.X.onDown.add(function(){
		this.interpolation = 'bezierInterpolation';
	},this);

	this.keys.C.onDown.add(function(){
		this.interpolation = 'linearInterpolation';
	},this);

	this.keys.A.onDown.add(function(){
		var pointer = game.input.activePointer;
		this.points.x.push(pointer.x);
		this.points.y.push(pointer.y);
	},this);

	this.keys.S.onDown.add(function(){
		if (this.currentIndex){
			this.points.x.splice(this.currentIndex,1);
			this.points.y.splice(this.currentIndex,1);
		}
	},this);

	this.keys.D.onDown.add(function(){
		this.points.x.pop();
		this.points.y.pop();
	},this);

};

G.LineEditor.prototype = Object.create(Phaser.Group.prototype);

G.LineEditor.prototype.update = function(){

	if (this.currentIndex){
		var pointer = game.input.activePointer;
		var diffX = this.pointerStart.x - pointer.x;
		var diffY = this.pointerStart.y - pointer.y;
		this.pointerStart.x = pointer.x;
		this.pointerStart.y = pointer.y;
		this.points.x[this.currentIndex] -= diffX;
		this.points.y[this.currentIndex] -= diffY;
	}

	this.redraw();

};

G.LineEditor.prototype.findCurrentIndex = function(pointer){

	var index = null;
	var min = Infinity;

	for (var i = 0; i < this.points.x.length; i++){
		var dist = game.math.distance(pointer.x,pointer.y,this.points.x[i],this.points.y[i]);
		if (dist < min){
			index = i;
			min = dist;
		}
	}

	if (min < 10){
		return index;
	}else{
		return index;
	}

};


G.LineEditor.prototype.redraw = function(){

	this.gfx.clear();
	this.drawLine();
	this.drawPoints();

};

G.LineEditor.prototype.drawPoints = function(){

	this.gfx.lineStyle(2,0x0000ff,1);
	this.gfx.beginFill(0x0000ff,0.5);
	for (var i = 0; i < this.points.x.length; i++){
		this.gfx.drawCircle(
			this.points.x[i],
			this.points.y[i],
			10
		);
	}

};

G.LineEditor.prototype.drawLine = function(){

	if (this.points.x.length == 0) return;

	this.gfx.lineStyle(2,0xff0000,1);
	this.gfx.moveTo(this.points.x[0],this.points.y[0]);
	for (var i = 0; i < 1; i+=0.001){
		var x = game.math[this.interpolation](this.points.x,i);
		var y = game.math[this.interpolation](this.points.y,i);
		this.gfx.lineTo(x,y);
	}

};